import React from "react"
import Navbar from "../../../../Common/Navbar"
import Footer from "../../../../Common/Footer"
import Sidebar from "../../../../Sidebar/Sidebar"
import EnquiryFormComp  from "./Component/EnquiryFormComp"

const EnquiryForm =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <EnquiryFormComp />
        </div>
        <Footer />
        </>
    )
}

export default EnquiryForm